import { createSelector } from '@reduxjs/toolkit';
import { personalDataItemsForMap } from './personal-data-items-for-map';
import { externalConnectionsForMap } from './external-connections-for-map';
import { getOrganization } from '../organization/getOrganization';
import type { RiskAssessmentViewModel } from '@trinnvis/dabih-api-client';
import { flatMap } from '../utilities/flatMap';
import { toList } from '../toList';

export const riskAssessmentMenuItemsForComputerMap = createSelector(
  personalDataItemsForMap,
  externalConnectionsForMap,
  getOrganization,
  (personalDataItemsForMap, externalConnectionsForMap, o) => {
    const r: { [key: string]: RiskAssessmentViewModel } = {};

    if (o === undefined) return r;
    /*
           computersForMap
             .flatMap(function(e) {
               return e.riskAssessments ?? [];
             })
             .forEach(function(e) {
               r[e] = o.riskAssessmentsById[e];
             });

       */

    flatMap(personalDataItemsForMap, function (e) {
      return e.riskAssessments ?? [];
    }).forEach(function (e) {
      r[e] = o.riskAssessmentsById[e];
    });

    flatMap(externalConnectionsForMap, function (e) {
      return e.riskAssessments !== undefined ? e.riskAssessments : [];
    }).forEach(function (e) {
      r[e] = o.riskAssessmentsById[e];
    });

    return toList(r).map(function (e) {
      return Object.assign({}, e, { pages: [20] });
    });
  },
);
